import { render, staticRenderFns } from "./contactFollowStage.vue?vue&type=template&id=7cb5c8a2&scoped=true"
import script from "./contactFollowStage.vue?vue&type=script&lang=js"
export * from "./contactFollowStage.vue?vue&type=script&lang=js"
import style0 from "./contactFollowStage.vue?vue&type=style&index=0&id=7cb5c8a2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb5c8a2",
  null
  
)

export default component.exports